<template>
    <div class="main">
        <el-dialog
            :title="openData.title"
            :visible.sync="openData.state"
            :close-on-click-modal="false"
            width="700px"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    :disabled="openData.title == '详情'"
                    label-position="left"
                    label-width="100px"
                    ref="formData"
                    :model="formData"
                    :rules="formDataRules"
                >
                    <el-form-item label="标题：" prop="problemTitle">
                        <el-input
                            v-model.trim="formData.problemTitle"
                            placeholder="请输入标题"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="问题：" prop="problem">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 2 }"
                            v-model.trim="formData.problem"
                            placeholder="请输入问题"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="答案：" prop="solution">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 2 }"
                            v-model.trim="formData.solution"
                            placeholder="请输入答案"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div
                slot="footer"
                class="dialog-footer dialog-footer-btn"
                v-if="openData.title != '详情'"
            >
                <el-button type="primary" @click="handleSubmit"
                    >确 定</el-button
                >
                <el-button @click="dialogVisibleClone">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ["openData"],

    data() {
        return {
            formData: {
                problemTitle: "",
                problem: "",
                solution: "",
            },
            formDataRules: {
                problemTitle: [
                    {
                        required: true,
                        message: "标题不能为空",
                        trigger: "blur",
                    },
                ],
                problem: [
                    {
                        required: true,
                        message: "问题不能为空",
                        trigger: "blur",
                    },
                ],
                solution: [
                    {
                        required: true,
                        message: "答案不能为空",
                        trigger: "blur",
                    },
                ],
            },
        }
    },
    created() {
        this.formData = {
            problemTitle: "",
            problem: "",
            solution: "",
        }
        if (this.openData.title != "新增") {
            this.getData()
        }
    },
    methods: {
        // 详情获取
        getData() {
            const self = this
            let params = {
                id: self.openData.id,
            }
            this.$http
                .request({
                    url: "/ypt/admin/problemBase/info/get",
                    method: "POST",
                    data: params,
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        let jsonTemp = { ...res.content }
                        self.formData.id = jsonTemp.id
                        self.formData.problemTitle = jsonTemp.problemTitle
                        self.formData.problem = jsonTemp.problem
                        self.formData.solution = jsonTemp.solution
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        handleSubmit() {
            let self = this

            this.$refs.formData.validate((valid) => {
                if (valid) {
                    if (
                        this.openData.title == "新增" ||
                        this.openData.title == "编辑"
                    ) {
                        let url = ""
                        let data = { ...self.formData }
                        url = "/ypt/admin/problemBase/info/save"
                        this.$http
                            .request({
                                url: url,
                                method: "POST",
                                data: {
                                    ...data,
                                },
                            })
                            .then((res) => {
                                if (res.code == 200) {
                                    this.$emit("cancleAddress", true)
                                    this.$message.success(res.message)
                                } else {
                                    this.$message.error(res.message)
                                }
                            })
                    }
                }
            })
        },
        dialogVisibleClone() {
            this.$emit("cancleAddress", false)
        },
    },
}
</script>
<style lang="less" scoped>
</style>